<template>
  <div v-if="isClosed" class="tw-w-full">
    <a
      :href="href"
      :class="{
        'tw-pointer-events-none': disabled,
      }"
      @click="navigate"
      ><div
        class="tw-flex tw-cursor-pointer tw-items-center tw-gap-4 tw-p-4 hover:tw-bg-primary-grey-400"
        :class="{
          'tw-bg-primary-grey-400 tw-px-4 tw-font-bold tw-shadow-[inset_0.1875rem_0] tw-shadow-white tw-transition-all dark:tw-shadow-primary-grey-500':
            isActive,
          'tw-text-primary-grey-200': disabled,
        }"
        :data-test-id="dataTestId"
      >
        <component :is="icon" /></div
    ></a>
  </div>
  <div v-else class="tw-w-full">
    <a
      :href="href"
      :class="{
        'tw-pointer-events-none': disabled,
      }"
      @click="navigate"
      ><div
        class="tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-gap-4 tw-p-4 hover:tw-bg-primary-grey-400"
        :class="{
          'tw-bg-primary-grey-400 tw-px-4 tw-font-bold tw-shadow-[inset_0.1875rem_0] tw-shadow-white tw-transition-all dark:tw-shadow-primary-grey-500':
            isActive,
          'tw-text-primary-grey-200': disabled,
        }"
        :data-test-id="dataTestId"
        @click="navigate"
      >
        <div class="tw-flex tw-flex-nowrap tw-items-center">
          <component :is="icon" /><span class="tw-ml-2">{{ label }}</span>
        </div>
        <slot name="pill" /></div
    ></a>
  </div>
</template>
<script setup lang="ts">
interface NavItemProps {
  label: string;
  icon: string;
  isClosed: boolean;
  navigate: (payload: MouseEvent) => void;
  href: string;
  isActive: boolean;
  dataTestId?: string;
  disabled?: boolean;
}

withDefaults(defineProps<NavItemProps>(), {
  dataTestId: "",
  disabled: false,
});
</script>
